import React, { useState } from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { ArrowDropDownOutlined, Settings } from "@mui/icons-material";
import { AppBar, Button, Box, Typography, IconButton, Toolbar, Menu, MenuItem, useTheme, Switch } from "@mui/material";
import { logout } from "features/auth/auth.slice";
import { Constants } from "utils/Constants";
import { setMode, reset } from "features/global/global.slice";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import GoogleTranslate from "./GoogleTranslate";
import LicenseNotice from "component/LicenseNotice";

const Links = {
  SETTINGS: "/settings",
};

const LeftSide = styled("Box")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});
const RightSide = styled("Box")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

const BoxContainer = styled("Box")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

const Navbar = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isResetPasswordPage = location.pathname === "/reset-password";
  const theme = useTheme();
  const { user } = useSelector((state) => state.auth);
  const { appConstants } = useSelector((state) => state.service);
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const userInfoParts = (() => {
    const userFullName = appConstants?.appUsers?.find((users) => users.userName == user.username);
    const name = userFullName?.name || "N.A";
    const username = (user?.username || "").toLowerCase();
    return { name, username };
  })();
  const toggleTheme = () => {
    dispatch(setMode());
  };

  // const getCustomerLogoSrc = () => {
  //   const name = appConstants?.appCustomerName?.toLowerCase();
  //   return name ? `/logos/${name}.png` : "/logos/mainman.png";
  // };

  return (
    <AppBar
      position="fixed"
      sx={{
        position: "fixed",
        width: { sm: `calc(100%-${props.drawerWidth}px)` },
        ml: { sm: `${props.drawerWidth}px` },
        backgroundColor: theme.palette.appColors.navBarBackground,
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", ml: { sm: `${props.drawerWidth}px`, minHeight: '80px', height: '80px' } }}>
        <LeftSide>
          {/*
          {!customerLogoExists ? (
            <Box
              sx={{ width: 200, resizeMode: "contain", marginLeft: -2, marginBottom: -4, marginTop: -3 }}
              component="img"
              src={customerLogo}
              alt="logo"
            />
          ) : null}
           */}
          {/* <Box
            component="img"
            src={getCustomerLogoSrc()}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop if default.png is missing
              e.target.src = "/logos/mainman.png";
            }}
            alt="Tenant Logo"
            sx={{
              width: 200,
              objectFit: "contain",
              marginLeft: -2,
              marginBottom: -4,
              marginTop: -3,
            }}
          /> */}

          <Typography
            variant="h2"
            fontWeight="bold"
            sx={{ color: "#fff", letterSpacing: 1, display: "flex", alignItems: "center", mr: 2 }}
          >
            {appConstants?.appCustomerName || ""}
          </Typography>
          <LicenseNotice />
        </LeftSide>
        <RightSide>
          <BoxContainer gap="1.5rem" sx={{ alignItems: "center" }}>
            <GoogleTranslate />
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
              <Typography variant="body2" sx={{}}>
                Dark Mode
              </Typography>
              <Switch
                checked={theme.palette.mode === "dark"}
                onChange={toggleTheme}
                color="secondary"
                icon={<LightModeIcon />}
                checkedIcon={<DarkModeIcon />}
              />
            </Box>
            {!isResetPasswordPage && (
              <BoxContainer>
                <Button
                  onClick={handleClick}
                  variant="contained"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textTransform: "none",
                    gap: "1rem",
                  }}
                >
                  <Box textAlign="left">
                    <Typography fontWeight="bold" fontSize="0.85rem" sx={{ textTransform: "none" }}>
                      <span style={{ textTransform: "capitalize" }}>{userInfoParts.name}</span>
                      {userInfoParts.username ? (
                        <span style={{ textTransform: "none" }}>{` (${userInfoParts.username})`}</span>
                      ) : null}
                    </Typography>
                    <Typography fontSize="0.75rem" sx={{}}>
                      {user && "roles" in user ? Constants.userRoles[user.roles[0]] : "N.A"}
                    </Typography>
                  </Box>
                  <ArrowDropDownOutlined sx={{ fontSize: "25px" }} />
                </Button>
                <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
                  <MenuItem
                    onClick={() => {
                      dispatch(reset());
                      dispatch(logout());
                    }}
                  >
                    Log Out
                  </MenuItem>
                </Menu>
              </BoxContainer>
            )}
            {user?.roles?.includes(appConstants?.allTypes?.USER_ROLES?.ROLE_MAINTENANCE_SUPERVISOR) && (
              <IconButton component={Link} to={Links.SETTINGS}>
                <Settings sx={{ color: "white" }} />
              </IconButton>
            )}
          </BoxContainer>
        </RightSide>
      </Toolbar>
    </AppBar>
  );
};
export default Navbar;
